import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PatientExam } from '../model/patient-exam';
import { Filter } from '../model/filter';
import { Patient } from '../model/patient';

@Injectable()
export class ResultApiService {

  protected apiUrl = environment.apiUrl + 'v1/results';

  constructor(private httpClient: HttpClient) { }

  public findByPatient(identificationType: string, identificationNumber: string): Observable<Array<PatientExam>> {
    return this.httpClient.get<Array<PatientExam>>(
      `${this.apiUrl}/patients?identificationType=${identificationType}&identificationNumber=${identificationNumber}`
    );
  }

  public download(requestCode: string, isPrevalidated: boolean, url?: string): Observable<Blob> {
    let params = '?prevalidated=' + isPrevalidated;
    if (url) {
      params += '&url=' + url
    }
    return this.httpClient.post(
      `${this.apiUrl}/patients/${requestCode}/pdf${params}`,
      {},
      { responseType: 'blob' }
    )
  }

  public findByParameters(filter: Filter): Observable<Array<Patient>> {
    filter = this.clean(filter);
    const objString = '?' + Object.keys(filter).map(key => {
      return `${key}=${encodeURIComponent(filter[key])}`;
    }).join('&');
    console.log('objString ', objString);
    return this.httpClient.get<Array<Patient>>(
      `${this.apiUrl}/labs${objString}`
    );
  }

  private clean(obj) {
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined) {
        delete obj[propName];
      }
    }
    return obj
  }


}
